import React from 'react';
import PropTypes from 'prop-types';
import { MAX_PHASE_DESCRIPTION_CHAR_LENGTH } from '../../../constants/constants';
import InputText from '../../Common/InputText';
import Toggle from '../../Common/Toggle/Toggle';
import TextArea from '../../Common/TextArea';
export default class PhaseForm extends React.Component {

    constructor(props, context) {
        super(props, context);

    }

    onTextChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit();
        return false;
    }

    render() {

        return (
            <div className="identifier-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"} onSubmit={this.onSubmit}>
                    <InputText name="name" label="Name" placeholder="Name" type="text" value={this.props.phase.name} onChange={this.onTextChange} isRequired={true} errorMessage="Name is required" />
                    <TextArea name="description" label="Description" rows={5} placeholder="Description" onChange={this.onTextChange} maxLength={MAX_PHASE_DESCRIPTION_CHAR_LENGTH} value={this.props.phase.description} />
                    { this.props.phase.description &&
                        <div className="remaining-chars text-end">{this.props.phase.description.length}/{MAX_PHASE_DESCRIPTION_CHAR_LENGTH}</div>                    
                    }
                    <Toggle name="isActive" text="Active" checked={this.props.phase.isActive} onChange={this.onToggleChange} />
                </form>
            </div>
        );
    }

}

PhaseForm.propTypes = {
    onFormChange: PropTypes.func.isRequired, // returns (field, value)
    isFormValid: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    phase: PropTypes.object
}
